import axios from 'axios';
import { LOCAL_COUNTRY } from '@/constants';
const baseApiUrl = 'services/customerservice/api/tls/consent';

export default class ConsentService {
  public unsubscribe(client: string, token: string): Promise<any> {
    return axios.post(`${baseApiUrl}/${client}/unsubscribe?token=${token}`);
  }

  public getConsentInfo(issuer: string): Promise<any> {
    return axios
      .get(`${baseApiUrl}/${LOCAL_COUNTRY}/${issuer}`)
      .then(res => res.data)
      .catch(error => console.log(error));
  }
}
